import makeStyles from '@material-ui/core/styles/makeStyles'
import {CancelButton, NextButton, Text} from '../../1elements'
import {validateClientSearch, validateImportType, validateLocationSearch} from '../../../services/util/editChecks'
import ButtonLayoutDiv from '../../4layout/ButtonLayoutDiv'
import ClientSearch from './ClientSearch'
import ContactImportTypeDropdown from '../../2compounds/Select/ContactImportTypeDropdown'
import {useState} from 'react'
import DataBulkImportTabTemplate from '../../5templates/DataBulkImportTabTemplate'
import {getItemFromSessionStorage} from '../../../services/util/sessionStorageManager'
import {downloadCsvTemplate} from '../../../services/util/miscellaneousService'
import ApiService from '../../../common/ApiCalls'
import LocationSearchByEndCustomerName from './LocationSearchByEndCustomerName'

const useStyles = makeStyles({
    root: {
        padding: '20px'
    },
    formDiv: {
        margin: '20px 0'
    }
})

const PeopleTab = ({selectedLocation, setSelectedLocation, onNextPeople, onCancel, showError, disabled, selectedClient,
                       setSelectedClient, importType, setImportType}) => {
    const classes = useStyles()
    const [isBulkImport, setIsBulkImport] = useState(false)
    const [, setIsErrorSnackbarOpen] = useState(false)
    const [templateHeaderList, setTemplateHeaderList] = useState([])

    const selectedClientName = selectedClient && selectedClient.end_customer_name

    const handleNextButton = () => {
        onNextPeople()
        if(importType === "Add multiple contacts"){
            setIsBulkImport(true)
        }
    }

    const defaultTabScreen = (
        <>
            <div className={classes.formDiv}>
                <Text type={'fieldLabel'}>Client Name<span className={'requiredAsterisk'} >*</span></Text>
                <ClientSearch selectedClient={selectedClient} setSelectedClient={setSelectedClient}
                              validation={showError&&validateClientSearch(selectedClient)} disabled={disabled}/>
            </div>

            <div className={classes.formDiv}>
                <Text type={'fieldLabel'}>Location Name<span className={'requiredAsterisk'} >*</span></Text>
                <LocationSearchByEndCustomerName selectedLocation={selectedLocation} setSelectedLocation={setSelectedLocation}
                                                 validation={showError&&validateLocationSearch(selectedLocation)} disabled={disabled||!selectedClient}
                                                 endCustomerName={selectedClientName} />
            </div>

            <ContactImportTypeDropdown value={importType} onChange={setImportType} disabled={disabled}
                                       validation={showError&&validateImportType(importType)} />

            <ButtonLayoutDiv>
                {onCancel && <CancelButton onClick={onCancel} /> }
                <NextButton onClick={handleNextButton} />
            </ButtonLayoutDiv>
        </>
    )

    const downloadTemplate = async () => {
        const header = await setTemplate()
        await downloadCsvTemplate(header, setIsErrorSnackbarOpen, 'template-people')
    }

    const setTemplate = async () => {
        const header = await ApiService().getContactTemplate()
        const headerArray = header.split(',')
        setTemplateHeaderList(headerArray)
        return header
    }
    const handleImportApi = async (data) => {
        const userId = window.localStorage.getItem('userId')
        const id = getItemFromSessionStorage('selectedLocation').id || undefined
        await ApiService().bulkImportContact(userId, data, id)
    }

    const bulkImportTabScreen = (
        <DataBulkImportTabTemplate dataType={'Location'}
                                   downloadTemplate={downloadTemplate} setTemplate ={setTemplate} templateHeaderList={templateHeaderList}
                                   handleImportApi={handleImportApi} formatPath={'/format/contacts'}/>
    )

    return(
        <div className={classes.root}>
            <Text type={'tabHeadingSecondary'}>Add people to an existing location</Text>
            {
                isBulkImport
                    ? bulkImportTabScreen
                    : defaultTabScreen
            }
        </div>
    )
}

export default PeopleTab